/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PortalChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PortalChirpService',
  rpcName: 'get',
  auth: 'app',
  fingerprint: 'Fzu39Mrdkk-UMJqtZ8KJlpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalTeamsRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PortalChirpService',
  rpcName: 'getPortalTeams',
  auth: 'app',
  fingerprint: 'GK9PRkKcsvW8sNxjKeY32pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};